import { Controller } from "../Controller";
import { ControllerRegistry } from "../../Registry/ControllerRegistry";
import { Menu as MenuTag } from "../../HTML/App/Menu";

export class AppMenu extends Controller {

    public clear() {
        this.getTag().clear();
    }

    public addItem(data: Map<string, any>) {
        this.getTag().addItem(data);
    }

    protected createTag(data: any) {
        this.addToData("tag", new MenuTag(data));
    }

    /**
     * @param data
     */
    protected initialize(data: Map<any, any>) {
        super.initialize(data);
        this.createTag(data);
    }

}

ControllerRegistry.register("AppMenu", AppMenu);
